export default{
    methods:{
        async getAllArchieveTickets(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/archive/get_all_archive', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getArchiveTicketById(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/archive/view_archive_ticket', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async reopenTicket(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/archive/reopen_ticket', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
    }
}